module.exports = __webpack_public_path__ + "img/c04_unittechgalleychampion_Normal_ua.9fcbc77b.webp";